export interface AXPageIdentity {
  readonly route: string;
  readonly identity: string;
  readonly isolated: boolean;
}

const AX_PAGE_IDENTITIES: readonly AXPageIdentity[] =
Object.freeze([
  {
    route: '/',
    identity: 'Landing',
    isolated: true,
  },
  {
    route: '/login',
    identity: 'Login',
    isolated: true,
  },
  {
    route: '/signup',
    identity: 'Signup',
    isolated: true,
  },
  {
    route: '/membership',
    identity: 'Membership',
    isolated: true,
  },
  {
    route: '/governor-command-center',
    identity: 'Command Center',
    isolated: true,
  },
]);

export function getAXPageIdentities():
readonly AXPageIdentity[] {
  return AX_PAGE_IDENTITIES;
}
